export default "__VITE_ASSET__8089f5d2__"